import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Speciality } from "../models/common-model";
import { CallCenterAddCallInBoundDetails, CallCenterAddCallOutBoundDetails } from "../models/call-center.model";
import { Subject, Observable, BehaviorSubject } from "rxjs";
import { DataSource } from "@angular/cdk/collections";
import { PostResponse } from '../models/common-model';

@Injectable({
  providedIn: "root",
})
export class CallCenterService {
  constructor(private http: HttpClient) { }

  //doubt it is used or not
  getAllSpecialities() {
    return this.http.get<Speciality[]>(
      environment.apiUrl + "LookUp/FetchAllSpecalities"
    );
  }

  getApptRequestModes() {
    return this.http.get<any>(
      environment.apiUrl + "CallCenter/GetAppointmentRequestModes"
    );
  }

  getCallHistory(payload) {
    return this.http.post<any>(
      environment.apiUrl + "CallCenter/FetchCallHistory",
      payload
    );
  }

  // @API    CallCenter/AddOutboundCallDetails
  // @Desc   Add OutBound Call Details
  // @Method  POST
  AddOutBoundCallDetails(payload: CallCenterAddCallOutBoundDetails): Observable<any> {
    return this.http.post<any>(environment.apiUrl + "CallCenter/AddOutboundCallDetails", payload);
  }

  // @API    CallCenter/AddInboundCallDetails
  // @Desc   Add InBound Call Details
  // @Method  POST
  AddInBoundCallDetails(payload: CallCenterAddCallInBoundDetails): Observable<any> {
    return this.http.post<any>(environment.apiUrl + "CallCenter/AddInboundCallDetails", payload);
  }

  FeedBackDetails(payload) {
    // debugger;
    return this.http.post<any>(
      environment.apiUrl + "CallCenter/InsertFeedbackFormDetails",
      payload
    );
  }

  searchGenAI(payload: any) {
    return this.http.post<any>(
      'https://crmaimodule.quad1test.com/api/question-answer/', // Ensure the URL is in quotes
      payload
    );
  }
  
  searchGenAI1(payload: any) {
    return this.http.post<any>(
      'https://crmaimodule.quad1test.com/api/question/', 
      payload
    );
  }
  UpdateCallStatusDetails(payload) {
    // debugger;
    return this.http.post<any>(
      environment.apiUrl + "CallCenter/UpdateCallInformation",
      payload
    );
  }

  // below all services are for data sharing bw components for call center module
  private selectedUHIDDetails = new BehaviorSubject<any>("");
  selectedUHID = this.selectedUHIDDetails.asObservable();
  ProceedToUHIDList(uhidDetails): any {
    this.selectedUHIDDetails.next(uhidDetails);
  }

  private CallStatus = new BehaviorSubject<any>("");
  selectedCallStatus = this.CallStatus.asObservable();
  UpdateCallStatus(callStatus): any {
    this.CallStatus.next(callStatus);
  }

  private currentState = new BehaviorSubject<any>("");
  selectedCurrentState = this.currentState.asObservable();
    afterCompleteOperationKnowTheStatus(currentState): any {
    this.currentState.next(currentState);
  }

  private viewHistory = new BehaviorSubject<any>("");
  selectedViewHistory = this.viewHistory.asObservable();
  shareDataBwPopupAndViewHistoryComponent(history): any {
    this.viewHistory.next(history);
  }

  //reschedule data sharing bw view uhid and reschedule components
  private rescheduleDetails = new BehaviorSubject<any>("");
  selectedRescheduleDetails = this.rescheduleDetails.asObservable();
  ProceedToReschedule(apptDetails): any {
    this.rescheduleDetails.next(apptDetails);
  }
  //Cancel appt data sharing bw view uhid and cancel components
  private cancelApptDetails = new BehaviorSubject<any>("");
  selectedCancelApptDetails = this.cancelApptDetails.asObservable();
  ProceedToCancelAppt(apptDetails): any {
    this.cancelApptDetails.next(apptDetails);
  }
  //Package inquiry data sharing bw view uhid and package inquiry components
  private PackageInquiryDetails = new BehaviorSubject<any>("");
  selectedPackageInquiryDetails = this.PackageInquiryDetails.asObservable();
  ProceedToPackageInquiry(apptDetails): any {
    this.PackageInquiryDetails.next(apptDetails);
  }

  //sample
  private triggerInboundCall = new BehaviorSubject<any>("");
  selectedTriggerInboundCall = this.triggerInboundCall.asObservable();
  triggerInboundCallComponent(data): any {
    this.triggerInboundCall.next(data);
  }

  getAutoDialerConfiguration() {
    return this.http.get<any>(environment.apiUrl + "CallCenter/GetAutoDialConfiguration");
  }

  UpdateAutoDialConfiguration(payload) {
    return this.http.post<any>(environment.apiUrl + "CallCenter/UpdateAutoDialConfiguration", payload);
  }

  getPackageEnquiryClinics() {
    return this.http.get<any>(environment.apiUrl + "CallCenter/GetPackageEnquiryClinics");
  }

  getPackageEnquiryHMSClinics() {
    return this.http.post<any>(environment.apiUrl + "HMS/GetAllClinicsWithoutFilter",'');
  }
  getLeadsCount( payload){
    return this.http.post<any>(environment.apiUrl + "AskApollo/GetMonthlyLeadsCount" ,payload);
  }

  getCompaignCount( payload){
    return this.http.post<any>(environment.apiUrl + "Campaign/FetchCampaignDashboard" ,payload);
  }

  getActivitiesCount( payload){
    return this.http.post<any>(environment.apiUrl + "ActivityManagment/FetchAllActivitiesDashBoardCount" ,payload);
  }

  getActivityLeadsCount( payload){
    return this.http.post<any>(environment.apiUrl + "ActivityManagment/FetchAllActivitiesLeadsCount" ,payload);
  }



  
    //To get the Area Pincode
  getAllAreaPincode(search) {
    return this.http.get(`${environment.apiUrl}CallCenter/GetAllPincodes?area=${search}`);
  }

  getDialysisCities() {
    return this.http.get<any>(environment.apiUrl + "CallCenter/GetDialysisCities");
  }

  getDialysisClinicsCityWise(CityId) {
    return this.http.get(`${environment.apiUrl}CallCenter/GetAllDialysisClinicsCityWise/?CityId=${CityId}`);
  }

  getPackageEnquiryData(payload) {
    return this.http.post<any>(environment.apiUrl + "CallCenter/GetPackageEnquiryData", payload);
  }

  setAchievementToDigitalMISBUWise(payload){
    return this.http.put<any>(environment.apiUrl + "CallCenter/InsertDigitalMISAchievementDetailsBUWise", payload);
  }

  setAchievementToDigitalMIS(payload){
    return this.http.put<any>(environment.apiUrl + "CallCenter/InsertDigitalMISAchievementDetails", payload);
  }

  updateAchievementToDigitalMISBUWise(payload,achievementId): Observable<PostResponse> {
    return this.http.post<PostResponse>(`${environment.apiUrl}CallCenter/UpdateDigitalMISAchievementDetailsBUWise/${achievementId}`,payload);
    }

  UpdatePackageEnquiryStatus(payload) {
    return this.http.post<any>(environment.apiUrl + "CallCenter/UpdatePackageEnquiryStatus", payload);
  }

  UpdateConfirmedAppointmentStatus(payload) {
    return this.http.post<any>(environment.apiUrl + "CallCenter/UpdateConfirmedAppointmentStatus", payload);
  }

  getPackageEnquiryDashboard() {
    return this.http.get<any>(environment.apiUrl + "Reports/GetAllPackageEnquiryDashboardData");
  }

  getPackageEnquiryDashboardClinicWise(clinicId) {
    return this.http.get<any>(`${environment.apiUrl}Reports/GetAllPackageEnquiryDashboardDataClinicWise?clinicId=${clinicId}`);
  }

  getPackageEnquiryClinicWiseCount() {
    return this.http.get<any>(environment.apiUrl + "Reports/GetPackageEnquiryLeadsCountClinicWise");
  }

  getLeadsRefreshTimeout() {
    return this.http.get<any>(environment.apiUrl + "CallCenter/GetRefreshTimeout");
  }
  UpdateRefreshTimeout(payload) {
    return this.http.post<any>(
      environment.apiUrl + "CallCenter/UpdateRefreshTimeout",
      payload
    );
  }
}
